// 前端錯誤上報（報告改版工單 17 第 8 點；後端工單 10 的 POST /front/v1/report/:reportId/client-error）。
// 由區塊 error boundary（CLIENT_RENDER：render、normalize／derive、區塊 chunk 載入失敗）與整頁錯誤畫面（CLIENT_DECRYPT）呼叫。
//   - 去重：同一頁面載入內，同報告＋同 blockId＋同 errorCode 只上報一次——上報端點與同報告的 GET 共用
//     「每 reportId 每小時 100 次」限流額度，不能讓上報吃掉報告本身的額度（10 實作紀錄 10-01）。
//   - 內容：src/report/errors.js 的 clientErrorPayload（errorCode／blockId／例外類型與階段／主報告 requestId／版本），
//     不含報告內容與個資。
//   - 靜默：端點不存在（舊後端 404）或失敗都不彈錯、不重試、不 console（apis/report.js 的 postClientError）。
import { postClientError } from '@/apis/report'
import { clientErrorKey, clientErrorPayload } from '@/report/errors'

const sent = new Set()

/**
 * @param {object} opts
 * @param {string} opts.reportId
 * @param {'CLIENT_RENDER'|'CLIENT_DECRYPT'} opts.errorCode
 * @param {string} [opts.blockId]
 * @param {string} [opts.stage]            'render'|'normalize'|'derive'|'chunk'|'chunk-autoreload'
 *                                        （chunk-autoreload＝渲染器 chunk 載入失敗、接著自動重新整理一次；issue #314）
 * @param {Error}  [opts.error]            只取 error.name（類型），不取訊息
 * @param {string} [opts.clientRequestId]  主報告回應的 requestId（後端 log 對照用）
 * @returns {boolean} 這次有沒有真的送出（去重後）
 */
export function reportClientError (opts = {}) {
  return send(opts).sent
}

/**
 * 同 reportClientError，但回傳「上報 POST 結束」的 promise（去重或不上報時立即 resolve；永不 reject）。
 * 給「先上報、再整頁重新整理」用（issue #314：chunk 載入失敗自動重整）——頁面一卸載進行中的 fetch 就會被取消。
 * @returns {Promise<boolean>} 這次有沒有真的送出
 */
export function reportClientErrorAndSettle (opts = {}) {
  const { sent: didSend, done } = send(opts)
  return done.then(() => didSend, () => didSend)
}

function send ({ reportId, errorCode, blockId, stage, error, clientRequestId } = {}) {
  const skipped = { sent: false, done: Promise.resolve() }
  if (!reportId) return skipped
  const payload = clientErrorPayload({ errorCode, blockId, stage, error, clientRequestId, appVersion: process.env.VERSION })
  if (!payload) return skipped
  const key = clientErrorKey({ reportId, blockId: payload.blockId, errorCode })
  if (sent.has(key)) return skipped
  sent.add(key)
  return { sent: true, done: Promise.resolve(postClientError(reportId, payload)) }
}
